import { render, staticRenderFns } from "./GameRow.vue?vue&type=template&id=496a26e4&scoped=true&"
import script from "./GameRow.vue?vue&type=script&lang=js&"
export * from "./GameRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496a26e4",
  null
  
)

export default component.exports